import { en } from './en';
import { vi } from './vi';
import type { UITranslations } from './types';

export type SupportedLocale = 'en' | 'vi';

const bundles: Record<SupportedLocale, UITranslations> = { en, vi };

let currentLocale: SupportedLocale = 'en';

/** Module-level default, for non-React call sites (or before a `UIProvider` mounts). */
export function setUILocale(locale: SupportedLocale): void {
    if (bundles[locale]) {
        currentLocale = locale;
    }
}

export function getUILocale(): SupportedLocale {
    return currentLocale;
}

export function getUIBundle(locale: SupportedLocale = currentLocale): UITranslations {
    return bundles[locale] ?? en;
}
